import React from "react";
import {
  Home,
  Calendar,
  LayoutTemplate,
  ListTodo,
  BarChart3,
  Users,
  Settings,
  Building2,
  FileText,
  Search,
  ArrowRight,
  CheckSquare,
  HelpCircle,
  Beaker,
  User,
  Shield,
  FlaskConical,
  CalendarCheck,
  TestTube,
  MoreHorizontal,
  UserCircle,
  ClipboardList
} from "lucide-react";

// Simple icon mapping function that returns React components
export const getNavigationIcon = (iconName: string): React.ReactNode => {
  const iconMap: Record<string, React.ReactNode> = {
    Dashboard: React.createElement(Home, { size: 24 }),
    Calendar: React.createElement(Calendar, { size: 24 }),
    Map2: React.createElement(LayoutTemplate, { size: 24 }),
    ListTodo: React.createElement(ListTodo, { size: 24 }),
    LineChartSolid2: React.createElement(BarChart3, { size: 24 }),
    ID: React.createElement(Users, { size: 24 }),
    CheckSquare: React.createElement(CheckSquare, { size: 24 }),
    HelpCircle: React.createElement(HelpCircle, { size: 24 }),
    CircleQuestionMark: React.createElement(HelpCircle, { size: 24 }),
    Beaker: React.createElement(Beaker, { size: 24 }),
    User: React.createElement(User, { size: 24 }),
    Settings: React.createElement(Settings, { size: 24 }),
    Settings2: React.createElement(Settings, { size: 24 }),
    Building: React.createElement(Building2, { size: 24 }),
    FileText: React.createElement(FileText, { size: 24 }),
    Search: React.createElement(Search, { size: 24 }),
    ArrowRight: React.createElement(ArrowRight, { size: 24 }),
    Contacts: React.createElement(ClipboardList, { size: 24 }),
    CircleStar: React.createElement(Calendar, { size: 24 }),
    Shield: React.createElement(Shield, { size: 24 }),
    Flask: React.createElement(FlaskConical, { size: 24 }), // Better icon for Alpha Features
    BookTick: React.createElement(CalendarCheck, { size: 24 }), // Better icon for Availability
    TestTube: React.createElement(TestTube, { size: 24 }), // Testing icon
    Drag2: React.createElement(MoreHorizontal, { size: 24 }), // More menu icon
    CircleUser: React.createElement(UserCircle, { size: 24 }) // User profile icon
  };

  return iconMap[iconName] || React.createElement(Home, { size: 24 });
};
